import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { StrictLocalizeFunction } from "@faire/web/common/localization";
import { isError } from "@faire/web/common/typescriptUtils";
import { WebApiError } from "@faire/web-api--source/WebApiError";

export const convertErrorToLoginError = (
  e: unknown,
  strictLocalize: StrictLocalizeFunction,
  isLoginAttempt?: {
    isMFALoginAttempt?: boolean;
  }
): LoginError => {
  if (e instanceof WebApiError) {
    if (e.httpStatusCode === 404) {
      return new LoginError(
        strictLocalize({
          defaultMessage:
            "There’s no account associated with that email. Try Again",
        }),
        e.httpStatusCode
      );
    } else if (e.httpStatusCode === 429) {
      return new LoginError(
        strictLocalize({
          defaultMessage:
            "Your account has been locked due to too many failed login attempts, try again in an hour.",
          description: {
            text: "Error message shown to user if they called our login endpoint too many times",
            img: "https://cdn.faire.com/fastly/aff2984cdbc29172ebf3e88dcbd345a7dbc47380a800749af1d6127857047bb6.png",
          },
        }),
        e.httpStatusCode
      );
    } else if (e.httpStatusCode === 400 && isLoginAttempt?.isMFALoginAttempt) {
      return new LoginError(
        strictLocalize({
          defaultMessage:
            "Invalid combination of email address, code and password.",
          description: {
            text: "Error message shown to user if they enter the wrong credentials",
            img: "https://cdn.faire.com/fastly/2bfce655806471489ec54fd5eca9ab570c1fa6ba9456214e8069a5203b989bd8.png",
          },
        })
      );
    }

    return new LoginError(e.message, e.httpStatusCode, e.responseData);
  }

  if (isError(e)) {
    return new LoginError(e.message);
  }

  return new LoginError(strictLocalize({ defaultMessage: "An error occured" }));
};
